import * as signalR from '@microsoft/signalr'
import { AuthApi } from '../services/auth'
import { useUserStore } from '../stores/user'
import { useToast } from 'vuestic-ui'

let connection: signalR.HubConnection | null = null
let started = false

export function startPresence() {
  if (started) return
  started = true

  const base = import.meta.env.VITE_API_BASE?.replace(/\/+$/, '') || ''
  const url = `${base}/hubs/presence`

  connection = new signalR.HubConnectionBuilder()
    .withUrl(url, {
      withCredentials: true,
    })
    .withAutomaticReconnect([0, 2000, 5000, 10000])
    .configureLogging(signalR.LogLevel.Information)
    .build()

  const { init } = useToast()
  const store = useUserStore()

  connection.onreconnecting((err: any) => console.log('[hub] reconnecting', err))
  connection.onreconnected((id: any) => console.log('[hub] reconnected', id))
  connection.onclose((err: any) => {
    console.log('[hub] closed', err)
    started = false
  })

  connection.on('rolePermissionsChanged', async (roleId: string) => {
    try {
      console.log(roleId)
      const { data } = await AuthApi.reissue()
      if (data?.permissions) store.setPermissions(data.permissions)
      if (data?.roles) store.setRoles(data.roles)

      init({ message: 'Yetkileriniz güncellendi.', color: 'info' })
    } catch (e) {
      window.location.href = '/auth/login?reauth=1'
    }
  })

  connection.on('userRolesChanged', async () => {
    try {
      const { data } = await AuthApi.reissue()
      if (data?.permissions) useUserStore().setPermissions(data.permissions)
      if (data?.roles) useUserStore().setRoles(data.roles)
      await useUserStore().fetchInitUserInfo()
      init({ message: 'Yetkileriniz güncellendi.', color: 'info' })
    } catch {
      window.location.href = '/auth/login?reauth=1'
    }
  })

  connection
    .start()
    .then(() => console.log('[hub] started'))
    .catch((err: any) => {
      console.error('[hub] start error', err)
      started = false
    })
}

export async function stopPresence() {
  if (connection) {
    try {
      await connection.stop()
    } catch (e: any) {
      console.log(e)
    }
    connection = null
  }
  started = false
}
